import { loadCurrentUser } from './auth';

export function initApp() {
  console.log('REDUX-ACTION: initApp() ...');
  return (dispatch) => {
    dispatch(loadCurrentUser());
  }
}
